// extracted by mini-css-extract-plugin
module.exports =  {"title":"foBW2Zu0piihiNsZBn2W"};